/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useQuery } from '@apollo/client';

import { MasterDirectoryTopLocationsDocument } from '@xing-com/crate-master-directory-graphql';

type EntryByLetterParams = {
  jobRole: string;
};

export const useGetTopLocations = ({
  jobRole,
}: EntryByLetterParams): {
  loading: boolean;
  collection: {
    displayName: string;
    url: string;
  }[];
} => {
  const { loading, data } = useQuery(MasterDirectoryTopLocationsDocument, {
    variables: {
      query: {
        keywords: jobRole,
        location: {
          radius: 20,
        },
      },
      consumer: 'loggedout.web.masterdirectory.locations',
      limit: 10000,
    },
  });

  const collection = (data?.jobSearchByQuery?.aggregations?.cities || []).map(
    (location) => ({
      displayName: location?.city?.name || '',
      url: `/jobs/${jobRole}-jobs-in-${(location?.city?.name || '').replace(/ /g, '-').toLowerCase()}`,
    })
  );

  return { loading, collection };
};
